import React from "react";
import {Cell, Legend, Pie, PieChart, Tooltip} from "recharts";

export default function PieChartComponent(props) {
return(
    <PieChart width={props.width} height={props.height}>
        {props.type === 1?
        <Pie label data={props.data} dataKey={props.dataKey} nameKey={props.nameKey} cx={props.cx} cy={props.cy} outerRadius={props.outerRadius}
             fill={props.fillColor?props.fillColor:"#8884d8"}>
            {
                props.data.map((entry, index) => <Cell key={`cell-${index}`}
                                                   fill={props.colorsList[index % props.colorsList.length]}/>)
            }
        </Pie>
            :
            <Pie label data={props.data} dataKey={props.dataKey} nameKey={props.nameKey} cx={props.cx} cy={props.cy} innerRadius={props.innerRadius}
                 outerRadius={props.outerRadius} fill={props.fillColor?props.fillColor:"#8884d8"}>
                {
                    props.data.map((entry, index) => <Cell key={`cell-${index}`}
                                                           fill={props.colorsList[index % props.colorsList.length]}/>)
                }
            </Pie>
        }

        {/*<Pie data={props.data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />*/}
        <Tooltip/>
        <Legend/>
    </PieChart>
)
}